export default __webpack_public_path__ + "static/media/detail-view-active-icon.8e6afea6.svg";